module.exports = __webpack_public_path__ + "static/media/paper-girls-vol4.2a588ea9.jpg";